import {
    Box,
    Button,
    Dialog,
    DialogActions,
    Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState } from "store";
import { sendOtp, verifyOtp } from "services/otpService";
import { Close } from "@mui/icons-material";
import { useDispatch } from 'react-redux';
import { setMobileVerified } from "./authSlice";
import { setUser } from "./otpSlice";



interface OtpDialogPropTypes {
  handleClose: () => void;
  // handleVerification: (otp: string) => void;
  handleResendCode?: () => void; 
}

const OtpVerifyDialog = ({handleClose}: OtpDialogPropTypes) => {
  const [otp, setOtp] = useState("");
  const mobileNumber = useSelector((state: RootState) => state.auth.mobileNumber);
  const [timer, setTimer] = useState(45); 
  const dispatch = useDispatch();

  const handleVerifyClick = async () => {
    if (otp.length !== 4) {
      return toast.error("Please enter a valid 4-digit OTP.");
    }
  
    try {
      const data = await verifyOtp(mobileNumber, otp);
      if (data) {
        dispatch(setMobileVerified(true));
        toast.success("Mobile number verified successfully.");
        handleClose();
        dispatch(setUser(data.id));
      }
    } catch (error :any ) {
       // Handle unexpected errors
      toast.error("Otp is Invalid");
      console.error("Error during handleVerifyClick:", error);
    }
  };

  const handleResendClick = () => {
    setTimer(45); // Reset the timer
    sendOtp(mobileNumber);
  };

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (interval) {
      clearInterval(interval);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [timer]);

  return (
    <Dialog open maxWidth="md" onClose={handleClose} PaperProps={{ sx: { borderRadius: 4, m: {xs: 2, md: 4} } }}>
      <Box p={6} pb={40} sx={{p: {xs: 2, md: 6}, pb: {xs: 20, md: 40}, }} minHeight={400}>
        <Box display='flex' justifyContent='space-between'>
        <Typography fontWeight={500} variant="h4">
          Enter Verification Code
        </Typography>
      
      <Box
      onClick={handleClose}
       sx={{
        cursor:'pointer'
      }}
      >
      <Close/>
      </Box>
  
      
      </Box>  
        <Typography color="#979797" fontSize={18} mt={1}>
          We’ve sent a verification code on mobile +91 {mobileNumber}
        </Typography>

        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={4}
          renderInput={(props) => <input {...props} />}
          containerStyle={{display: "flex", justifyContent: "space-between", margin: "40px 0"}}
          inputStyle={{width: 50, height: 50, fontSize: 18, border: "1px solid #979797", borderRadius: 6}}
        />
        <Box display="flex" justifyContent="space-between">
        <Typography color="text.secondary"
        sx={{
          cursor:'pointer'
        }}
        >
            Didn’t get a code?{" "}
            {timer > 0 ? (
              <span>{timer}s</span>
            ) : (
              <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={handleResendClick}
              >
                Resend Code
              </span>
            )}
          </Typography>

          <Button variant="contained"
              disabled={otp.length !== 4}
              onClick={handleVerifyClick}
            >Verify</Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default OtpVerifyDialog;
